<p-toast position="top-right"></p-toast>

<div class="user-info-container">
  <!-- Header Section -->
  <div class="user-profile-header">
    <img
      *ngIf="userData?.avatar !== null"
      [src]="baseApiUrl + userData?.avatar"
      title="icon-person"
      [alt]="userData?.firstName"
      class="avatar"
    />
    <img
      *ngIf="userData?.avatar === null"
      src="assets/icons/icon-profile.png"
      alt="User Avatar"
      class="avatar"
    />

    <!-- Availability Dot -->
    <span class="availability-dot" *ngIf="userData?.isAvailability"></span>
    <span class="tb-badge" *ngIf="userData?.userType === userTypeConstants.TALKING_BUDDY">
      <img class="profile-tb-logo" src="assets/icons/tb-logo.svg" alt="Talking Buddy Badge" />
    </span>
    <h2
      [ngClass]="{ 'heading-without-tb': userData?.userType !== userTypeConstants.TALKING_BUDDY }"
    >
      {{ userData?.firstName !== null ? userData?.firstName : 'Anonymous' }}
      {{ userData?.lastName }} |
      {{
        (userType === userTypeConstants.TALKING_BUDDY
          ? 'USER_DETAILS_PAGE.TALKING_BUDDY'
          : 'USER_DETAILS_PAGE.CALLER'
        ) | translate
      }}
    </h2>

    <button
      pButton
      size="small"
      [label]="
        userData?.isBlocked
          ? ('USER_PAGE.FILTER_LABELS.BLOCKED' | translate)
          : ('USER_PAGE.FILTER_LABELS.ACTIVE' | translate)
      "
      [class]="userData?.isBlocked ? 'p-button-danger' : 'p-button-secondary'"
      (click)="updateBlockStatus(userData)"
      class="action-button"
    ></button>
  </div>

  <div
    class="main-content"
    [ngClass]="{ 'collapsed-content': sidebarCollapsed, 'expanded-content': !sidebarCollapsed }"
  >
    <div class="row g-2">
      <!-- Left Side Card -->
      <div class="col-md-6">
        <div class="stat-card h-100">
          <div class="user-left-details">
            <p><i class="pi pi-envelope"></i> {{ userData?.email }}</p>
            <p><i class="pi pi-phone"></i> {{ userData?.phoneNumber }}</p>
            <p>
              <i class="pi pi-map-marker"></i> {{ userData?.city }}, {{ userData?.region }},
              {{ userData?.country }}
            </p>
            <p><i class="pi pi-globe"></i> {{ userData?.country }}</p>
            <p *ngIf="shouldShowPaymentProfileColumn()">
              <i class="pi pi-user"></i>
              {{ 'USER_DETAILS_PAGE.PAYMENT_PROFILE' | translate }}
              <span
                class="tag tag-outlined"
                [ngClass]="{
                  'tag-success': userData?.accountKycStatus === 'Completed',
                  'tag-warning': userData?.accountKycStatus !== 'Completed',
                }"
              >
                <i class="pi pi-verified" *ngIf="userData?.accountKycStatus === 'Completed'"></i>
                <span>{{ userData?.accountKycStatus }}</span>
              </span>
            </p>
          </div>
          <div class="user-right-details">
            <p>
              <i class="pi pi-calendar-plus"></i>
              {{
                userData?.createdOn
                  ? (getConvertedDate(userData?.createdOn || '') | date: 'dd-MMM-YYYY')
                  : ''
              }}
            </p>
            <p>
              <i class="fa fa-venus" aria-hidden="true" *ngIf="userData?.gender === 'Female'"></i
              ><i class="fa fa-mars" aria-hidden="true" *ngIf="userData?.gender === 'Male'"></i>
              {{ userData?.gender }}
            </p>
            <p>
              <i class="fa fa-venus" aria-hidden="true" *ngIf="userData?.gender === 'Female'"></i
              ><i class="fa fa-mars" aria-hidden="true" *ngIf="userData?.gender === 'Male'"></i>
              {{ formatPronouns(userData?.pronouns) }}
            </p>
            <p>
              <i class="pi pi-calendar"></i>
              {{
                userData?.dateOfBirth
                  ? (getConvertedDate(userData?.dateOfBirth || '') | date: 'dd-MMM-YYYY')
                  : ''
              }}
            </p>
          </div>
        </div>
      </div>

      <!-- Right Side: Two In-line Cards -->
      <div class="col-md-6">
        <div class="d-flex gap-3 h-100">
          <!-- CALLER Statistics Card -->
          <div
            class="stat-card stat-card-vertical stat-card-caller h-100 py-2"
            *ngIf="userType === userTypeConstants.CALLER"
          >
            <div class="stat-container">
              <h2>{{ userStatisticsResponse?.totalCalls || 0 }}</h2>
              <p>{{ 'USER_DETAILS_PAGE.CARDS_LABELS.TOTAL_CALLS' | translate }}</p>
            </div>
            <div class="horizontal-line"></div>
            <div class="stat-container">
              <h2>
                {{
                  userStatisticsResponse?.totalSpent || 0
                    | currency: userStatisticsResponse?.currency
                }}
              </h2>
              <p>{{ 'USER_DETAILS_PAGE.CARDS_LABELS.TOTAL_SPENT' | translate }}</p>
            </div>
            <div class="horizontal-line"></div>
            <div class="stat-container">
              <h2>
                {{
                  userStatisticsResponse?.availableWalletBalance || 0
                    | currency: userStatisticsResponse?.currency
                }}
              </h2>
              <p>{{ 'USER_DETAILS_PAGE.CARDS_LABELS.WALLET_BALANCE' | translate }}</p>
            </div>
          </div>

          <!-- NON-CALLER Statistics Card -->
          <div
            class="stat-card stat-card-vertical stat-card-non-caller h-100 py-2"
            *ngIf="userType !== userTypeConstants.CALLER"
          >
            <div class="stat-container">
              <h2>
                {{
                  userStatisticsResponse?.lifetimeEarning || 0
                    | currency: userStatisticsResponse?.currency
                }}
              </h2>
              <p>{{ 'USER_DETAILS_PAGE.CARDS_LABELS.LIFETIME_EARNINGS' | translate }}</p>
            </div>
            <div class="horizontal-line"></div>
            <div class="stat-container">
              <h2>
                {{
                  userStatisticsResponse?.totalPayoutAmount || 0
                    | currency: userStatisticsResponse?.currency
                }}
              </h2>
              <p>{{ 'USER_DETAILS_PAGE.CARDS_LABELS.TOTAL_PAYOUT' | translate }}</p>
            </div>
            <div class="horizontal-line"></div>
            <div class="stat-container">
              <h2>
                {{
                  userStatisticsResponse?.eligibleWalletBalance || 0
                    | currency: userStatisticsResponse?.currency
                }}
              </h2>
              <p>{{ 'USER_DETAILS_PAGE.CARDS_LABELS.ELIGIBLE' | translate }}</p>
            </div>
            <div class="horizontal-line"></div>
            <div class="stat-container">
              <h2>
                {{
                  userStatisticsResponse?.availableWalletBalance || 0
                    | currency: userStatisticsResponse?.currency
                }}
              </h2>
              <p>{{ 'USER_DETAILS_PAGE.CARDS_LABELS.AVAILABLE' | translate }}</p>
            </div>
          </div>
          <div class="stat-card stat-card-vertical h-100 py-2">
            <div class="stat-container">
              <h2>{{ userStatisticsResponse?.totalDisputes || 0 }}</h2>
              <p>{{ 'USER_DETAILS_PAGE.CARDS_LABELS.TOTAL_RAISED_DISPUTE' | translate }}</p>
            </div>
            <div class="horizontal-line"></div>
            <div class="stat-container">
              <h2>{{ userStatisticsResponse?.openDisputes || 0 }}</h2>
              <p>{{ 'USER_DETAILS_PAGE.CARDS_LABELS.OPEN_DISPUTES' | translate }}</p>
            </div>
            <div class="horizontal-line"></div>
            <div class="stat-container">
              <h2>{{ userStatisticsResponse?.underReviewDisputes || 0 }}</h2>
              <p>{{ 'USER_DETAILS_PAGE.CARDS_LABELS.IN_REVIEW_DISPUTE' | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Filters Section -->
  <div
    class="row g-2 user-details-section"
    [ngClass]="{ 'collapsed-content': sidebarCollapsed, 'expanded-content': !sidebarCollapsed }"
  >
    <div class="col-md-6">
      <div class="d-flex justify-content-between align-items-center">
        <h5>{{ 'USER_DETAILS_PAGE.CALL_HISTORY' | translate }}</h5>
        <div class="filter-item">
          <p-calendar
            id="fromToDate"
            [(ngModel)]="filters.dateRange"
            selectionMode="range"
            [showButtonBar]="true"
            [readonlyInput]="true"
            placeholder="{{ 'USER_DETAILS_PAGE.PLACEHOLDERS.SELECT_DATE_RANGE' | translate }}"
            dateFormat="dd-M-yy"
            (click)="onCalendarOpen()"
            (ngModelChange)="onFilterChange()"
          >
          </p-calendar>
        </div>
      </div>
      <div class="table-section">
        <p-table
          [value]="userCallItems.length !== 0 ? userCallItems : noDataRow"
          [paginator]="userCallItems.length !== 0 ? true : false"
          [rows]="rows"
          [first]="first"
          [totalRecords]="totalRecords"
          [lazy]="true"
          (onPage)="pageChange($event)"
          (onSort)="sortChange($event)"
          [rowsPerPageOptions]="tableParams.ROW_PER_PAGE"
          [scrollable]="true"
          sortField="CreatedOn"
          [sortOrder]="-1"
        >
          <ng-template pTemplate="header">
            <tr>
              <th
                *ngIf="userType === userTypeConstants.CALLER"
                class="table-head"
                pSortableColumn="TalkingBuddyName"
              >
                {{ 'USER_DETAILS_PAGE.USER_CALL_TABLE.TALKING_BUDDY' | translate }}
                <p-sortIcon field="TalkingBuddyName"></p-sortIcon>
              </th>
              <th
                *ngIf="userType !== userTypeConstants.CALLER"
                class="table-head"
                pSortableColumn="CallerName"
              >
                {{ 'USER_DETAILS_PAGE.USER_CALL_TABLE.CALLER' | translate }}
                <p-sortIcon field="CallerName"></p-sortIcon>
              </th>
              <th class="table-head" pSortableColumn="CreatedOn">
                {{ 'USER_DETAILS_PAGE.USER_CALL_TABLE.CALL_DATE' | translate }}
                <p-sortIcon field="CreatedOn"></p-sortIcon>
              </th>
              <th class="table-head">
                {{ 'USER_DETAILS_PAGE.USER_CALL_TABLE.CALL_DURATION' | translate }}
              </th>
              <th
                pSortableColumn="CallCost"
                class="table-head"
                *ngIf="userType === userTypeConstants.CALLER"
              >
                {{ 'USER_DETAILS_PAGE.USER_CALL_TABLE.CALL_COST' | translate }}
                <p-sortIcon field="CallCost"></p-sortIcon>
              </th>
              <th
                pSortableColumn="MoneyEarned"
                class="table-head"
                *ngIf="userType !== userTypeConstants.CALLER"
              >
                {{ 'USER_DETAILS_PAGE.USER_CALL_TABLE.MONEY_EARNED' | translate }}
                <p-sortIcon field="MoneyEarned"></p-sortIcon>
              </th>
              <th class="table-head">
                {{ 'USER_DETAILS_PAGE.USER_CALL_TABLE.DISPUTE_STATUS' | translate }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-call>
            <tr
              *ngIf="userCallItems?.length !== 0"
              (click)="redirectToCallDetailsPage(call.id)"
              class="user-row"
            >
              <td *ngIf="userType === userTypeConstants.CALLER">{{ call.talkingBuddyName }}</td>
              <td *ngIf="userType !== userTypeConstants.CALLER">{{ call.callerName }}</td>
              <td>
                {{
                  call?.createdOn
                    ? (getConvertedDate(call?.createdOn || '') | date: 'dd-MMM-YYYY')
                    : ''
                }}
              </td>

              <td class="text-primary">{{ call.callDuration }}</td>
              <td *ngIf="userType !== userTypeConstants.CALLER" class="text-info fw-normal">
                {{ call.moneyEarned || 0 | currency: call.moneyEarnedCurrency }}
              </td>
              <td *ngIf="userType === userTypeConstants.CALLER" class="text-info fw-normal">
                {{ call.callCost || 0 | currency: call.callCostCurrency }}
              </td>
              <td *ngIf="call.hasDispute === true">
                <span class="badge open-dispute"> {{ statuses.OPEN_REQUEST }} </span>
              </td>
              <td *ngIf="call.hasDispute === false">
                <span class="badge no-dispute">
                  {{ statuses.NO_DISPUTE }}
                </span>
              </td>
            </tr>
            <tr *ngIf="userCallItems?.length === 0">
              <td colspan="5" class="no-data-available">
                {{ 'COMMON.NO_AVAILABLE' | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="col-md-6">
      <h5 *ngIf="userType === userTypeConstants.CALLER">
        {{ 'USER_DETAILS_PAGE.PREFERENCE_TB' | translate }}
      </h5>
      <h5
        *ngIf="userType === userTypeConstants.TALKING_BUDDY || userType === userTypeConstants.ADMIN"
      >
        {{ 'USER_DETAILS_PAGE.PREFERENCE_CALLER' | translate }}
      </h5>
      <div class="preferences-grid table-section">
        <div class="preference-item" *ngFor="let preference of preferences; let i = index">
          <p [ngClass]="{ 'first-p': i === 0 }">{{ preference.label }}</p>
          <span>{{ preference.value }}</span>
        </div>
      </div>
      <!-- Only if user is talking buddy -->
      <div *ngIf="userType !== userTypeConstants.CALLER">
        <div class="d-flex align-items-center">
          <h5 class="mt-4 fw-light-bold">
            {{ 'USER_DETAILS_PAGE.AVAILABILITY' | translate }}
          </h5>
          <div class="availability-switch">
            <p-inputSwitch [ngModel]="userData?.isAvailability" [disabled]="true"></p-inputSwitch>
          </div>
        </div>
        <p-table [value]="noDataRow" class="custom-table">
          <ng-template pTemplate="header" class="table-head">
            <tr>
              <th>{{ 'USER_DETAILS_PAGE.AVAILABILITY_DAYS.MONDAY' | translate }}</th>
              <th>{{ 'USER_DETAILS_PAGE.AVAILABILITY_DAYS.TUESDAY' | translate }}</th>
              <th>{{ 'USER_DETAILS_PAGE.AVAILABILITY_DAYS.WEDNESDAY' | translate }}</th>
              <th>{{ 'USER_DETAILS_PAGE.AVAILABILITY_DAYS.THURSDAY' | translate }}</th>
              <th>{{ 'USER_DETAILS_PAGE.AVAILABILITY_DAYS.FRIDAY' | translate }}</th>
              <th>{{ 'USER_DETAILS_PAGE.AVAILABILITY_DAYS.SATURDAY' | translate }}</th>
              <th>{{ 'USER_DETAILS_PAGE.AVAILABILITY_DAYS.SUNDAY' | translate }}</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body">
            <!-- Loop through availabilityData to render each row -->
            <tr *ngFor="let availability of availabilityData">
              <td>{{ availability.mondayTime || 'N/A' }}</td>
              <td>{{ availability.tuesdayTime || 'N/A' }}</td>
              <td>{{ availability.wednesdayTime || 'N/A' }}</td>
              <td>{{ availability.thursdayTime || 'N/A' }}</td>
              <td>{{ availability.fridayTime || 'N/A' }}</td>
              <td>{{ availability.saturdayTime || 'N/A' }}</td>
              <td>{{ availability.sundayTime || 'N/A' }}</td>
            </tr>
            <tr *ngIf="availabilityData.length === 0">
              <td colspan="7" class="no-data-available">
                {{ 'COMMON.NO_AVAILABLE' | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
